import React from 'react';
import { Colors } from 'shared-react/dist/styles';

interface BitPayLogoProps {
  color?: string;
}

export const SvgBusinessIcon: React.FC<BitPayLogoProps> = ({ color = Colors.Go }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.375 0.625C17.125 0.25 16.75 0 16.25 0H3.75C3.25 0 2.875 0.25 2.625 0.625C0 5.625 0 5.875 0 6.25C0 7.625 1.125 8.75 2.5 8.75V18.75C2.5 19.5 3 20 3.75 20H16.25C17 20 17.5 19.5 17.5 18.75V8.75C18.875 8.75 20 7.625 20 6.25C20 5.875 20 5.625 17.375 0.625ZM12.5 17.5V12.5H7.5V17.5H5V8.375C5.375 8.625 5.75 8.75 6.25 8.75C7 8.75 7.625 8.375 8.125 7.875C8.625 8.375 9.25 8.75 10 8.75C10.75 8.75 11.375 8.375 11.875 7.875C12.375 8.375 13 8.75 13.75 8.75C14.25 8.75 14.625 8.625 15 8.375V17.5H12.5Z" fill={color}/>
    </svg>
  );
};

export default SvgBusinessIcon;
